import React from "react";
import { SLIDES, CAMPAIGN } from "./swachhataContent";
import SlideRenderer from "./SwachhataSlides";

/*
 * The learning deck — module tabs across the top + the module text at full
 * width + footer nav — shared by the school modal (SwachhataModal) and the
 * public student page (Pages/SwachhataPublic). The caller owns the navigation
 * state; this component only renders it. (The `logo` prop callers still pass
 * is ignored: the client asked for no logo panel here.)
 */
export default function SwachhataDeck({
  slide,
  maxVisited,
  dir = "fwd",
  scrollRef,
  onGo,
  onBack,
  onFinish,
  onExit, // optional: shows an "Exit" button in the footer
  finishLabel = "Take the quiz →",
  finishTone = "orange",
  unlockAll = false,
  audience = "school", // 'school' | 'student' (tweaks the caption)
}) {
  const LAST = SLIDES.length - 1;
  const current = SLIDES[slide];
  const pct = Math.round(((slide + 1) / SLIDES.length) * 100);
  const caption = audience === "student" ? "Student learning track" : "Learning material";

  return (
    <div className="shs-learn shs-learn--tabs">
      {/* module tabs across the top (replaces the left rail) */}
      <div className="shs-tabs">
        <div className="shs-tabs__head">
          <span className="shs-tabs__kicker">{`${CAMPAIGN.name} · ${CAMPAIGN.slogan} · ${caption}`}</span>
          <span className="shs-tabs__count">{`Module ${slide + 1} of ${SLIDES.length}`}</span>
        </div>
        <ol className="shs-tabs__list">
          {SLIDES.map((s, i) => {
            const locked = i > maxVisited && !unlockAll;
            const done = i !== slide && (i < slide || i < maxVisited);
            return (
              <li
                key={s.key}
                className={`shs-tab ${i === slide ? "is-active" : ""} ${done ? "is-done" : ""} ${locked ? "is-locked" : ""}`}
                onClick={() => !locked && onGo(i)}
                title={locked ? "Read the previous modules first" : s.title}
              >
                <span className="shs-tab__num">{done ? "✓" : i + 1}</span>
                <span className="shs-tab__text">
                  <span className="shs-tab__label">{s.rail}</span>
                  <small className="shs-tab__sub">{`Module ${i + 1}`}</small>
                </span>
              </li>
            );
          })}
        </ol>
        <div className="shs-bar shs-tabs__bar"><i style={{ width: `${pct}%` }} /></div>
      </div>

      <div className="shs-main">
        <div className="shs-main__scroll" ref={scrollRef}>
          <div className={`shs-slide ${dir === "back" ? "shs-slide--back" : ""}`} key={current.key}>
            <SlideRenderer slide={current} onStartQuiz={onFinish} />
          </div>
        </div>
        <div className="shs-footer">
          <div className="shs-footer__left">
            <div className="shs-footer__dots">
              {SLIDES.map((s, i) => <span key={s.key} className={`shs-dot ${i === slide ? "is-active" : ""} ${i < slide ? "is-done" : ""}`} />)}
            </div>
            <div className="shs-kbd">Use <kbd>←</kbd> <kbd>→</kbd> to navigate</div>
          </div>
          <div className="shs-footer__actions">
            {onExit && (
              <button type="button" className="shs-btn shs-btn--exit shs-btn--sm" onClick={onExit}>✕ Exit</button>
            )}
            {slide === 0 ? (
              <button type="button" className="shs-btn shs-btn--ghost shs-btn--sm" onClick={onBack}>← Back</button>
            ) : (
              <button type="button" className="shs-btn shs-btn--ghost shs-btn--sm" onClick={() => onGo(slide - 1)}>← Previous</button>
            )}
            {slide < LAST ? (
              <button type="button" className="shs-btn shs-btn--primary shs-btn--sm shs-btn--pulse" onClick={() => onGo(slide + 1)}>
                Next <span className="shs-btn__arrow">→</span>
              </button>
            ) : (
              <button type="button" className={`shs-btn shs-btn--${finishTone} shs-btn--sm`} onClick={onFinish}>{finishLabel}</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
